import { render, staticRenderFns } from "./CatalogItemModal.vue?vue&type=template&id=20253112&scoped=true&"
import script from "./CatalogItemModal.vue?vue&type=script&lang=js&"
export * from "./CatalogItemModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemModal.vue?vue&type=style&index=0&id=20253112&scoped=true&lang=css&"
import style1 from "./CatalogItemModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20253112",
  null
  
)

export default component.exports